import { BMPrimitives, useBMTheme } from '../../../theme';
export const useButtonStyle = (role, size, buttonStyle) => {
    const { BMComponents } = useBMTheme();
    // default size: normal & role: primary
    let styles = {
        backgroundColor: BMComponents.BMUiButtonBgcolorPrimary,
        activeBackgroundColor: BMComponents.BMUiButtonBgcolorPrimaryHovertap,
        color: BMComponents.BMUiButtonInkPrimary,
        borderColor: 'transparent',
    };
    switch (size) {
        case 'LARGE':
            styles = {
                ...styles,
                paddingHorizontal: BMComponents.BMUiButtonHmarginLarge,
                height: BMComponents.BMUiButtonHeightLarge,
                textVariant: BMPrimitives.BMTypography.uiHuge,
            };
            break;
        case 'INSET':
            styles = {
                ...styles,
                paddingHorizontal: BMComponents.BMUiButtonHmarginSmall,
                height: BMComponents.BMUiButtonHeightInset,
                textVariant: BMPrimitives.BMTypography.uiSmall,
            };
            break;
        default:
        case 'NORMAL':
            styles = {
                ...styles,
                paddingHorizontal: BMComponents.BMUiButtonHmarginNormal,
                height: BMComponents.BMUiButtonHeightNormal,
                textVariant: BMPrimitives.BMTypography.uiNormal,
            };
            break;
    }
    switch (role) {
        case 'SECONDARY':
            styles = {
                ...styles,
                backgroundColor: BMComponents.BMUiButtonBgcolorSecondary,
                activeBackgroundColor: BMComponents.BMUiButtonBgcolorSecondaryHovertap,
                color: BMComponents.BMUiButtonInkSecondary,
                borderColor: 'transparent',
            };
            break;
        case 'PAY':
            styles = {
                ...styles,
                backgroundColor: BMComponents.BMUiButtonBgcolorPay,
                activeBackgroundColor: BMComponents.BMUiButtonBgcolorPayHoverTap,
                color: BMComponents.BMUiButtonInkPay,
                borderColor: 'transparent',
            };
            break;
        default:
        case 'PRIMARY':
            styles = {
                ...styles,
                backgroundColor: BMComponents.BMUiButtonBgcolorPrimary,
                activeBackgroundColor: BMComponents.BMUiButtonBgcolorPrimaryHovertap,
                color: BMComponents.BMUiButtonInkPrimary,
                borderColor: 'transparent',
            };
            break;
    }
    const btnStyle = { ...styles, ...buttonStyle };
    return btnStyle;
};
